/* GR SPECIAL ORDERS (Claude 2026-09-27) · the example-slip engine (homepage band + page hero).
   One clock per stage: .gso-tick's CSS animation. Each of its loop ends (animationiteration) inks the next example request.
   No timers: off screen the clock is paused (IntersectionObserver toggles .is-live), so nothing runs and nothing swaps.
   Reduced motion: there is no animation at all, so example 1 simply stays (example 2 if the first photo fails to load).
   The slip is complete in the server HTML. */
(function () {
  'use strict';
  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  function ink(field, text) {
    if (!field || field.children.length < 2 || !text) return;
    var a = field.children[0], b = field.children[1];
    var on = a.classList.contains('is-on') ? a : b, off = on === a ? b : a;
    if (on.textContent === text) return;
    off.textContent = text;
    on.classList.remove('is-on');
    off.classList.add('is-on');
  }

  function cycle(stage) {
    var list, base;
    try { list = JSON.parse(stage.querySelector('.gso-data').textContent); } catch (e) { return; }
    if (!list || list.length < 2) return;
    base = stage.getAttribute('data-gso-base') || '';
    var set = function (u) { return base + u + '?width=500 500w, ' + base + u + '?width=800 800w, ' + base + u + '?width=1100 1100w, ' + base + u + '?width=1400 1400w'; };
    var i = 0, busy = false, ready = -1, imgs = stage.querySelectorAll('.gso-photo img');
    var fb = stage.querySelector('[data-f="b"]'), ft = stage.querySelector('[data-f="to"]');
    var warm = function (k) {
      var x = list[k % list.length];
      if (!x.img || !imgs[0]) return;
      var im = new Image(); im.sizes = imgs[0].sizes; im.srcset = set(x.img);
    };
    /* the words and the bottle change TOGETHER, once the new photo has decoded; ticks during a pending decode are skipped */
    var next = function (now) {
      var k = (i + 1) % list.length, x = list[k];
      var show = function () { i = k; ink(fb, x.b); ink(ft, x.to); warm(k + 2); };
      if (imgs.length > 1 && x.img) {
        var on = imgs[0].classList.contains('is-on') ? imgs[0] : imgs[1], off = on === imgs[0] ? imgs[1] : imgs[0];
        var swap = function () { on.classList.remove('is-on'); off.classList.add('is-on'); show(); };
        if (ready === k) { ready = -1; swap(); return; }
        var t0 = performance.now();
        var want = set(x.img);
        if (off.getAttribute('srcset') !== want) off.setAttribute('srcset', want);
        off.loading = 'eager';
        busy = true;
        var go = function () { busy = false; if (!off.complete || !off.naturalWidth) { i = k; return; } if (!now && performance.now() - t0 > 300) { ready = k; return; } swap(); };
        if (off.decode) off.decode().then(go, go); else go();
      } else show();
    };
    stage.addEventListener('animationiteration', function (e) { if (e.animationName === 'gso-tick' && !busy) next(false); });
    /* the first bottle failed (a renamed file, a dropped connection): show the next example at once, never an empty stage for a loop */
    var first = imgs[0];
    var dead = function () { if (i === 0 && !busy && first.classList.contains('is-on') && first.complete && !first.naturalWidth) next(true); };
    if (first) { first.addEventListener('error', dead); dead(); }
    stage.__gsoWarm = function () { warm(2); };
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    for (var k = 0; k < es.length; k++) {
      var t = es[k].target;
      t.classList.toggle('is-live', es[k].isIntersecting);
      if (es[k].isIntersecting && t.__gsoWarm) { t.__gsoWarm(); t.__gsoWarm = null; } /* fetch the next bottle only once the band is seen */
    }
  }, { rootMargin: '40px 0px' }) : null;

  function boot() {
    var els = document.querySelectorAll('[data-gso-stage]');
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      if (el.__gso) continue;
      el.__gso = 1;
      if (el.hasAttribute('data-gso-cycle')) cycle(el); /* under reduced motion no tick ever fires: cycle() only arms the first-bottle fallback */
      if (RM) continue;
      if (io) io.observe(el); else { el.classList.add('is-live'); if (el.__gsoWarm) el.__gsoWarm(); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
